import { PayloadAction } from '@reduxjs/toolkit';
import { ChatMessagePayload } from 'features/chat/types';
import { selectIsRecorderSession } from 'features/recorder/recorderSlice';
import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

const CRASH_COMMAND = '/recorder:crash';
const KILL_SOCKET_COMMAND = '/recorder:close-socket';

// Throws to reach rootSaga's fatal catch, which runs the same teardown a real
// recorder crash triggers — without forging a recorder token to test it.
export function* crashRecorderProbeSaga({ payload }: PayloadAction<ChatMessagePayload>) {
  const isRecorderSession: boolean = yield select(selectIsRecorderSession);

  if (!isRecorderSession) {
    return;
  }

  const command = payload.message?.trim();

  if (command === KILL_SOCKET_COMMAND) {
    // Reproduces the janus_error shape: signaling is gone before the report,
    // so the backend sees only the close and Sentry gets the dropped-report capture.
    yield call(SignalingSocket.close, undefined, 'recorder_probe_socket_kill');
    throw new Error('Recorder probe: recorder signaling socket killed by chat command');
  }

  if (command === CRASH_COMMAND) {
    throw new Error('Recorder probe: forced recorder fatal crash by chat command');
  }
}
